/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LoginResponse, AxiosResponse } from 'api';
import { getTokens, INVALID_LOGIN_MESSAGE, logout } from './auth-middleware';
import storage from 'utils/storageController';

type UserAuth = {
    access_token: string;
    isAuthenticated: boolean;
    error: string;
};

const initialState: UserAuth = {
    access_token: '',
    isAuthenticated: false,
    error: '',
};

export const authSlice = createSlice({
    name: 'app/auth',
    initialState,
    reducers: {
        setTokens: {
            reducer: (state, action: PayloadAction<any>) => {
                state.access_token = action.payload.access_token;
                state.isAuthenticated = true;
            },
            prepare: (tokensResp) => {
                storage.setRefreshToken(tokensResp.refresh_token);
                return { payload: tokensResp };
            },
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTokens.fulfilled, (state, action) => {
                state.access_token = (
                    action.payload as AxiosResponse<LoginResponse>
                ).data.access_token;
                state.isAuthenticated = true;
                state.error = '';
            })
            .addCase(getTokens.pending, (state) => {
                state.error = '';
            })
            .addCase(getTokens.rejected, (state, action) => {
                state.error =
                    typeof action.payload === 'string' && action.payload.trim()
                        ? action.payload
                        : INVALID_LOGIN_MESSAGE;
            })
            .addCase(logout.fulfilled, () => {
                return {
                    access_token: '',
                    isAuthenticated: false,
                    error: '',
                };
            });
    },
});

export const { setTokens } = authSlice.actions;
export default authSlice.reducer;
